import React from 'react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="border-t border-white/5 py-12 bg-navy" data-id="element-75">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-76">
        <div className="flex flex-col items-center md:items-start gap-2" data-id="element-77">
          <a href="#" className="flex items-center" data-id="element-78">
            <img src="https://cdn.magicpatterns.com/uploads/xtgWxKgk7LvgDaYASSWAq2/Cognisensus_logo_traced_(1).svg" alt="Cognisensus" className="h-8" style={{
            filter: 'brightness(0) invert(1)'
          }} data-id="element-79" />
          </a>
          <p className="text-sm text-offwhite-muted font-light" data-id="element-80">
            Aligning Leadership and Machine Intelligence
          </p>
        </div>

        <div className="flex gap-8 text-sm text-offwhite-muted font-light" data-id="element-81">
          <a href="#" className="hover:text-amber transition-colors" data-id="element-82">
            Privacy
          </a>
          <a href="#" className="hover:text-amber transition-colors" data-id="element-83">
            Terms
          </a>
          <a href="#" className="hover:text-amber transition-colors" data-id="element-84">
            Twitter
          </a>
          <a href="#" className="hover:text-amber transition-colors" data-id="element-85">
            LinkedIn
          </a>
        </div>

        <div className="text-sm text-offwhite-muted/50 font-light" data-id="element-86">
          &copy; {currentYear} Cognisensus Inc.
        </div>
      </div>
    </footer>;
}